module.exports = "/_next/static/images/overhaul_recommendations_mobile_desktop-0df3d5b492584092db7fe35f59ff98f2.jpeg";